import React from 'react'
import ModalBase from 'components/Luxkit/Modal/ModalBase'
import { EnabledFilters } from 'components/Search/type'
import HotelSearchPageFilterPane from 'components/Pages/HotelSearchPage/HotelSearchPageFilterPane'
import TextButton from 'components/Luxkit/Button/TextButton'
import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import { OfferListSortOption } from 'constants/offerListFilters'

interface Props {
  filters: App.OfferListFilters;
  search: string;
  region?: string;
  enabledFilters: EnabledFilters;
  open?: boolean;
  onClose?: () => void;
  fetching: boolean;
  sortOptions?: Array<OfferListSortOption>;
}

function OfferListFilterSidebar(props: Props) {
  const { open, onClose, fetching, sortOptions, filters, search, enabledFilters } = props

  return (
    <ModalBase
      mode="drawer"
      isOpen={open}
      onClose={onClose}
    >
      <ModalBody>
        <HotelSearchPageFilterPane
          fetching={fetching}
          filters={filters}
          mapViewURL=""
          search={search}
          enabledFilters={enabledFilters}
          sortOptions={sortOptions}
        />
      </ModalBody>
      <ModalFooter>
        <TextButton kind="primary" size="large" onClick={onClose}>
          View Offers
        </TextButton>
      </ModalFooter>
    </ModalBase>
  )
}
export default OfferListFilterSidebar
